import { LoaderFunctionArgs, redirect } from "react-router";

export default async function communicationsLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/communications/inbox");
  return routeParams;
}
